import { CSSObject, Global } from '@emotion/react';
import { Box } from '@gemini/core';
import { addError } from '@mfe-helpers/datadog';
import ErrorFallback from '@mfe-presentation/components/ErrorFallback';
import { ErrorBoundary } from 'react-error-boundary';

const cardContainerStyles = (): CSSObject => ({
    '.card-container:empty': {
        display: 'none',
        minWidth: 0,
    },
});

const EstimationResultBlock = ({ children }: { children: React.ReactNode }) => {
    return (
        <ErrorBoundary
            fallback={<ErrorFallback mode="partial" />}
            onError={async (err) => addError(err)}
        >
            <Box
                unsafe_className="estimation-result-block"
                display="flex"
                flexDirection={{
                    'breakpoint.base': 'column',
                    'breakpoint.md': 'row',
                }}
                alignItems="flex-start"
                gap="spacing.24"
                width="100%"
            >
                <Global styles={() => cardContainerStyles()} />
                {children}
            </Box>
        </ErrorBoundary>
    );
};

export default EstimationResultBlock;
